import { DomainAttributes } from '../types-uidefinition';

/**
 * Performance optimized attribute value parsing
 */
export const parseAttributeValue = (raw:string) => {
  const value = raw && raw.trim();
  if(value === 'null') { return null }
  if(value === '' || value === 'undefined') { return undefined }  
  const numeric = Number(value);
  if(Number.isFinite(numeric)) { return numeric }
  if(typeof value === 'string' && 
    ( value.match(/^(true|false)$/i) )
  ){
    return JSON.parse(value.toLowerCase() );
  }
  return value;  
};

/**
 * Return an object representing prefixed attribute strings, matched case insensitive
 * 
 * example
 * 
 *    input: 
 * 
 *    [ {name:'label.Showlabel', value: 'True'}, {name: 'label.text', value:"false"} ] 
 * 
 * 
 *    // Note how Showlabel will be invalid component prop due to it's casing
 *    returns: {Showlabel=true, text=false}
 */
const prefixRegexCache = new Map();
export function parsePrefixed(prefix: string, attributes: DomainAttributes[]): any {
  if (!prefixRegexCache.has(prefix)) {
    const prefixRegex = new RegExp(`^${prefix}\.`, 'i');
    prefixRegexCache.set(prefix, prefixRegex);
  }
  
  if (!attributes || !attributes.length ){
    return {};
  }

  return attributes
    .filter(a => a.name.match(prefixRegexCache.get(prefix)))
    .reduce((aggr: object, v: DomainAttributes) => {
      const prop = v.name.split('.')[1];      
      aggr[prop] = parseAttributeValue(v.value as string);
      return aggr;
    }, {});
}
